import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { QuizAssessmentForm } from '../CreateQuizAssessment/CreateQuizAssessment';
import { CustomError } from 'views/error/customError';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { MultiCaseStudyForm } from '../CreateCaseStudy/MultiCaseStudyForm';

export const AssessmentRouter = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { diyQuizId, assessmentId } = useParams();
    const [loading, setLoading] = useState(true);
    const [assessment, setAssessment] = useState(null);
    const [error, setError] = useState(null);
    const [type, setType] = useState('')

    useEffect(() => {
        const fetchAssessment = async () => {
            try {
                if (assessmentId) {
                    const response = await axios.get(`/api/diy-quiz/${diyQuizId}/assessments/${assessmentId}`);
                    setAssessment(response.data.data);
                    setType(response.data?.data?.type)
                } else {
                    setType(searchParams.get('type'))
                }
            } catch (err) {
                setError(err.message || 'Failed to fetch assessment data');
            } finally {
                setLoading(false);
            }
        };

        fetchAssessment();
    }, [assessmentId, diyQuizId, searchParams]);
    if (loading) {
        return <LoadingBackdrop isOpen={loading} />
    }
    if (error || (assessmentId && (!assessment.status || !["draft" , "published"].includes(assessment.status))) || !type) {
        navigate('/nopermission');
        return;
    }

    switch (type) {
        case 'quiz':
            return <QuizAssessmentForm assessmentData={assessment} />;
        case 'case-study':
            return <MultiCaseStudyForm initialData={assessment} />;
        default:
            return (
                <CustomError
                    title={'Invalid Assessment Type'}
                    text={`The assessment type "${type}" is not recognized. Please use a valid type such as "quiz" or "case-study" `}
                    buttonText={'Back to Assessments'}
                    buttonLink={`/diy-quiz/${diyQuizId}/assessments`}
                />
            )
    }
};